import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Redirect, Route, Switch } from "react-router-dom";
import { debounce } from "lodash";

import Login from "./Login";
import Activate from "./Activate";
import LoggedInContent from "./LoggedInContent";
import PropTypes from "prop-types";
import Loader from "../ui/Loader";
import TopBar from "../topbar/TopBar";
import BreakForthOneSchedule from "../tempPages/BreakForthOneSchedule";
import Linker from "../shared/Linker";
import OneLinker from "../shared/OneLinker";
import XOLinker from "../shared/XOLinker";
import TestLinker from "../shared/TestLinker";
import TermsPage from "../pages/Terms";
import PrivacyPage from "../pages/Privacy";
import FormViewer from "../shared/FormViewer";
import VerifyEmailActivity from "../pages/Activity/VerifyEmailActivity";
import DeleteAccountActivity from "../pages/Activity/DeleteAccountActivity";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as responsiveActions from "../../actions/responsiveActions";
class Content extends Component {
	constructor(props) {
		super(props);
		this.state = {
			quickMessageList: {},
			newQuickMessage: this.newQuickMessage,
		};
	}

	static getDerivedStateFromProps = (props, state) => {
		const { controlPanel } = props;
		const { quickMessages } = controlPanel;
		let newState = Object.assign({}, state);
		const { quickMessageList } = newState;
		quickMessages.forEach(message => {
			if (!(message.id in quickMessageList)) {
				quickMessageList[message.id] = Object.assign({}, { step: "new" });
				setTimeout(() => {
					state.newQuickMessage(message.id);
				}, 50);
			}
		});
		return newState;
	};

	componentDidMount = () => {
		this.checkIfResponsive();
		window.addEventListener("resize", debounce(this.checkIfResponsive, 250));
	};

	checkIfResponsive = () => {
		const {
			responsive: { isResponsive },
			responsiveActions,
		} = this.props;
		let newResponsive;
		if (window.innerWidth < 992) {
			newResponsive = true;
		} else {
			newResponsive = false;
		}

		if (isResponsive !== newResponsive) {
			responsiveActions.updateResponsive(newResponsive);
		}
	};

	newQuickMessage = id => {
		let quickMessageList = Object.assign({}, this.state.quickMessageList);
		quickMessageList[id] = Object.assign({}, quickMessageList[id], { step: "show" });
		this.setState({ quickMessageList });
		setTimeout(() => {
			this.dismissQuickMessage(id);
		}, 5000);
	};

	dismissQuickMessage = id => {
		let quickMessageList = Object.assign({}, this.state.quickMessageList);
		quickMessageList[id] = Object.assign({}, quickMessageList[id], { step: "dismiss" });
		this.setState({ quickMessageList });
		setTimeout(() => {
			let quickMessageList = Object.assign({}, this.state.quickMessageList);
			delete quickMessageList[id];
			this.setState({ quickMessageList }, () => {
				this.props.controlPanelActions.removeQuickMessage(id);
			});
		}, 2000);
	};

	renderQuickMessages = () => {
		const { controlPanel } = this.props;
		const { quickMessages } = controlPanel;
		const { quickMessageList } = this.state;
		let top = 60;
		return quickMessages.map(message => {
			let { step } = quickMessageList[message.id];
			let t = top;
			if (step !== "done") {
				if (step !== "dismiss") {
					top += 60;
				}
				return (
					<div
						key={message.id}
						style={{ top: `${t}px` }}
						className={`quick-message ${quickMessageList[message.id].step} ${message.status}`}
						onClick={() => this.dismissQuickMessage(message.id)}
					>
						<i className={`fal fa-${message.icon}`}></i>
						<div className="quick-text">{message.message}</div>
					</div>
				);
			} else {
				return null;
			}
		});
	};

	dismissError = () => {
		this.props.controlPanelActions.displayError(undefined);
	};

	render() {
		const { auth, controlPanel, responsive } = this.props;
		const { isResponsive, isDropdownOpen } = responsive;
		if (!auth.user && !auth.isLoading) {
			return (
				<Switch>
					<Route path="/prestonwood-goc" exact component={Linker} />
					<Route path="/one2020" exact component={OneLinker} />
					<Route path="/xo-marriage" exact component={XOLinker} />
					<Route path="/deeplink-testing" exact component={TestLinker} />
					<Route path="/breakforthoneschedule" exact component={BreakForthOneSchedule} />
					<Route path="/forms" exact component={FormViewer} />
					<Route path="/terms" exact component={TermsPage} />
					<Route path="/privacy" exact component={PrivacyPage} />
					<Route path="/activate/:appKey/:userId" exact component={Activate} />
					<Route path="/activity/verify-email/:appKey" exact component={VerifyEmailActivity} />
					<Route path="/activity/delete/:appKey" exact component={DeleteAccountActivity} />
					<Route
						render={props => {
							return (
								<div>
									{this.renderQuickMessages()}
									<Login {...props} />
								</div>
							);
						}}
					/>
				</Switch>
			);
		}
		if (this.props.location.pathname === "/apps" && this.props.apps.currentAppId) {
			return <Redirect to="/" />;
		}

		return (
			<>
				<div>
					<div className={`coverall more global-coverall${controlPanel.isLoading ? " on" : ""}`}></div>
					<div className={`global-modal${controlPanel.isLoading ? " on" : ""}`}>
						<Loader />
					</div>
					<Switch>
						<Route path="/apps" exact render={props => <TopBar {...props} isFullWidth />} />
						<Route path="/apps/add" exact render={props => <TopBar {...props} isFullWidth />} />
						<Route path="/apps/:appKey/experiences/:expId/pages/new" component={TopBar} />
						<Route path="/apps/:appKey/experiences/:expId/pages/copy" component={TopBar} />
						<Route path="/apps/:appKey/experiences/:expId/pages/:pageId" component={TopBar} />
						<Route path="/apps/:appKey/experiences/new" component={TopBar} />
						<Route path="/apps/:appKey/experiences/copy" component={TopBar} />
						<Route path="/apps/:appKey/experiences/:expId" component={TopBar} />
						<Route path="/apps/:appKey" component={TopBar} />
					</Switch>

					{auth.user && (
						<Switch>
							<Route path="/breakforthoneschedule" exact component={BreakForthOneSchedule} />
							<Route path="/prestonwood-goc" exact component={Linker} />
							<Route path="/one2020" exact component={OneLinker} />
							<Route path="/xo-marriage" exact component={XOLinker} />
							<Route path="/deeplink-testing" exact component={TestLinker} />
							<Route path="/forms" exact component={FormViewer} />
							<Route path="/activity/verify-email/:appKey" exact component={VerifyEmailActivity} />
							<Route path="/activity/delete/:appKey" exact component={DeleteAccountActivity} />
							<Route
								path="/apps/add"
								exact
								render={props => {
									return (
										<div>
											<div
												className={`coverall global-coverall${
													controlPanel.errorMessage ? " on" : ""
												}`}
												onClick={() => this.dismissError()}
											></div>
											<div
												className={`global-error-message${
													controlPanel.errorMessage ? " on" : ""
												}`}
												onClick={() => this.dismissError()}
											>
												{controlPanel.errorMessage}
											</div>
											{this.renderQuickMessages()}
											<LoggedInContent {...props} />
										</div>
									);
								}}
							/>
							<Route
								render={props => {
									return (
										<section
											className={`content${isResponsive && isDropdownOpen ? " frozen" : ""}`}
											style={{
												marginTop: 50,
											}}
										>
											<div
												className={`coverall global-coverall${
													controlPanel.errorMessage ? " on" : ""
												}`}
												onClick={() => this.dismissError()}
											></div>
											<div
												className={`global-error-message${
													controlPanel.errorMessage ? " on" : ""
												}`}
												onClick={() => this.dismissError()}
											>
												{controlPanel.errorMessage}
											</div>
											{this.renderQuickMessages()}
											<LoggedInContent {...props} />
										</section>
									);
								}}
							/>
						</Switch>
					)}
				</div>
				<footer id="footer-navigation">
					<a
						href="https://get.brushfire.help/hc/en-us/articles/360011675720-Terms-of-Use"
						target="_blank"
						rel="noopener noreferrer"
					>
						Terms of Use
					</a>

					<a
						href="https://get.brushfire.help/hc/en-us/articles/360011675740-Privacy-Policy"
						target="_blank"
						rel="noopener noreferrer"
					>
						Privacy Policy
					</a>

					<a href="https://www.brushfire.com/support/" target="_blank" rel="noopener noreferrer">
						Support
					</a>
				</footer>
			</>
		);
	}
}
const mapStateToProps = state => ({
	apps: state.apps,
	auth: state.auth,
	controlPanel: state.controlPanel,
	responsive: state.responsive,
	user: state.user,
});

const mapDispatchToProps = dispatch => ({
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	responsiveActions: bindActionCreators(responsiveActions, dispatch),
});

Content.propTypes = {
	apps: PropTypes.object,
	auth: PropTypes.object,
	controlPanel: PropTypes.object,
	controlPanelActions: PropTypes.object,
	location: PropTypes.object,
	responsive: PropTypes.object,
	user: PropTypes.object,
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Content)
);
